import {
  HISTORY_MANPOWERS_SENDING_FETCHING,
  HISTORY_MANPOWERS_SENDING_FAILED,
  HISTORY_MANPOWERS_SENDING_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case HISTORY_MANPOWERS_SENDING_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case HISTORY_MANPOWERS_SENDING_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case HISTORY_MANPOWERS_SENDING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
